import React from 'react';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Card from 'src/components/common/Card.redesign';
import LeaseGenerationTractDetail from 'src/models/leasing/LeaseGenerationTractDetail';
import './OwnerPageStyles.scss';
import Project from 'src/models/Project';
import { AnyObject } from 'final-form';
import OwnershipContactCategoryForm from 'src/models/OwnershipContactCategoryForm';
import PagedResultSet from 'src/models/common/PagedResultSet';
import ProjectStaff from 'src/models/ProjectStaff';
import { SelectItem } from 'src/models/common/SelectItem';
import AgreementUtil from 'src/util/AgreementUtil';
import ContractGenerationTractDetail from '../LeasingComponents/redesign/ContractGenerationModels/ContractGenerationTractDetail';
import Ownership from 'src/models/tract_detail/Ownership';
import TractLegalDescription from 'src/components/common/TractLegalDescription';

interface IOwnerTractsProps {
    projectData?: Project;
    tracts?: Array<LeaseGenerationTractDetail>;
    surfaceTracts?: Array<ContractGenerationTractDetail>;
    clientNumber: number;
    projectNumber: number;
    maxHeight?: string;
    readonly?: boolean;
    projectStaff?: PagedResultSet<ProjectStaff>;
    contactCategories?: OwnershipContactCategoryForm;
    ownerships?: Array<Ownership>;

    navigate?: (path: string) => void;
}

class IOwnerTracts extends React.Component<IOwnerTractsProps> {
    handleTractClick = (tract: LeaseGenerationTractDetail | ContractGenerationTractDetail) => {
        if (!!this.props.projectData) {
            window.localStorage.setItem('ownerPage_SelectedTract', `${tract?.id}`);
            window.localStorage.setItem('ownerPage_SelectedTract_Client', `${this.props?.clientNumber}`);
            window.localStorage.setItem('ownerPage_SelectedTract_Project', `${this.props?.projectData?.projectNumber}`);
            this.props.navigate(AgreementUtil.navigateToTract(tract, this.props?.projectData?.tractTypeId, this?.props?.clientNumber, this.props?.projectNumber));
        }

        return console.log('no nav implementation!');
    };

    getOwnershipTypeAlias = (type: string) => {
        switch (type) {
            case 'NON-PARTICIPATING':
                return 'NPRI';
            case 'NON-EXECUTIVE':
                return 'NEMI';
            case 'REMAINDERMAN':
                return 'REM';
            case 'TRANSFER ON DEATH':
                return 'TOD';
            case 'TRANSFER ON DEATH':
                return 'TOD';
            case 'NAKED OWNER':
                return 'NKDO';
            case 'HEIR':
                return 'HEIR';
            default:
                return '';
        }
    };

    public render() {
        const leaseBuyers =
            this.props.projectStaff && this.props.projectStaff.items.length > 0
            ? this.props.projectStaff.items
                .map((landman: AnyObject) => new SelectItem(landman.id, landman.user.firstName + ' ' + landman.user.lastName))
            : undefined;

        return (
            <CardContainer className="owner-tracts-results" style={{ overflowY: 'scroll', marginTop: '1rem', maxHeight: this.props.maxHeight ? this.props.maxHeight : '25vh' }}>
                {this.props.tracts &&
                    (this.props.tracts as Array<LeaseGenerationTractDetail>).map((x: LeaseGenerationTractDetail, index) => {
                        return (
                            <Card
                                key={`tractList.${index}`}
                                badge={AgreementUtil.getGlobalId(x, x.parentTractType)}
                                onClick={() => !this.props.readonly ? this.handleTractClick(x) : null}
                                className="note-highlight"
                                style={{ marginTop: '1rem' }}
                                rightBadgePanel={`${x?.leasedStatus} ${(!!x.additionalOwnershipType && x.additionalOwnershipType) !== 'FEE' ? ', ' + this.getOwnershipTypeAlias(x.additionalOwnershipType) : ''}`}
                                rightBadgePanelstyle={{whiteSpace: 'nowrap', background: '#dddcdc', fontSize: '11.5px'}}
                            >
                                <div style={{ margin: '.2rem' }}>
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ marginRight: '1rem' }}>Lease Buyer:</div>
                                        <div className="owner-tract-legal-description">{leaseBuyers ? leaseBuyers.find(lb => lb.id === x.leaseBuyer)?.name : ''}</div>
                                    </div>
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ marginRight: '1rem' }}>Contact Category:</div>
                                        {/* tslint:disable-next-line:max-line-length */}
                                        <div className="owner-tract-legal-description">{this.props.contactCategories ? this.props.contactCategories.categories.find(cc => cc.id === x.ownershipContactCategoryId)?.name : ''}</div>
                                    </div>
                                </div>
                                <div style={{ margin: '.2rem' }}>
                                    <div style={{ display: 'flex' }}>
                                        <TractLegalDescription
                                            style={{ marginRight: '1rem' }}
                                            index={index}
                                            legalDescription={x?.legalDescription}
                                        />
                                    </div>
                                    {/*<div style={{ display: 'flex' }}>
                                        <div style={{ marginRight: '1rem' }}>Legal Description:</div>
                                        <div className="owner-tract-legal-description">{x.legalDescription}</div>
                                    </div>*/}
                                </div>
                                <div style={{ margin: '.2rem', display: 'flex', justifyContent: 'space-between', borderTop: '1px solid lightgrey' }}>
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ marginRight: '1rem' }}>Gross:</div>
                                        <div>{x.grossAcres}</div>
                                    </div>

                                    <div style={{ display: 'flex' }}>
                                        <div style={{ marginRight: '1rem' }}>Interest:</div>
                                        <div>{x.decimalInterest}</div>
                                    </div>

                                    <div style={{ display: 'flex' }}>
                                        <div style={{ marginRight: '1rem' }}>Net:</div>
                                        <div>{(x.grossAcres * x.decimalInterest).toFixed(7)}</div>
                                    </div>
                                </div>
                            </Card>
                        );
                    })}
                {this.props.tracts && this.props.tracts?.length === 0 && (
                    <Card>
                        <p style={{ marginLeft: '1rem' }}>No Tracts for this Owner</p>
                    </Card>
                )}
            </CardContainer>
        );
    }
}

export default IOwnerTracts;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/OwnerTracts.tsx